// // desktop filter (start)
document.addEventListener('DOMContentLoaded', () => {
  const maxVisible = 8;
  const expandedBlocks = new Set();
  const collapsedByUser = new Set();
  const facetsShow = document.querySelector('.facets__show')
  const textMore = facetsShow.dataset.more;
  const textLess = facetsShow.dataset.less;  

  function setupShowMore() {
    document.querySelectorAll('.js-facet-list--horizontal').forEach((list, index) => {
      const displayBlock = list.closest('.facets__display');
      if (!displayBlock) return;
      
      const details = displayBlock.closest('details');
      const filterLabel = details ? details.querySelector('.facets__summary-text')?.textContent?.trim() : '';
      const filterKey = filterLabel || displayBlock.dataset.index || index;
      
      const items = [...list.children];
      
      if (items.length <= maxVisible) {
        const button = displayBlock.querySelector('.show-more-btn');
        if (button) {
          button.closest('.facets__show').remove();
        }
        return;
      }
      
      const wasExpanded = expandedBlocks.has(filterKey) && !collapsedByUser.has(filterKey);
      
      let button = displayBlock.querySelector('.show-more-btn');
      if (!button) {
        const existingShowDiv = displayBlock.querySelector('.facets__show');
        if (existingShowDiv && !existingShowDiv.querySelector('.show-more-btn')) {
          button = document.createElement('button');
          button.className = 'show-more-btn';
          button.type = 'button';
          existingShowDiv.appendChild(button);
        }
      }
      
      if (!button) return;
      
      let expanded = wasExpanded;
      
      const updateItemsVisibility = () => {
        items.forEach((item, index) => {
          if (index >= maxVisible) {
            item.style.display = expanded ? 'block' : 'none';
          } else {
            item.style.display = 'block';
          }
        });
        
        button.textContent = expanded ? textLess : textMore;
        
        if (expanded) {
          displayBlock.classList.add('facets-expanded');
          expandedBlocks.add(filterKey);
          collapsedByUser.delete(filterKey);
        } else {
          displayBlock.classList.remove('facets-expanded');
          expandedBlocks.delete(filterKey);
        }
      };
      
      updateItemsVisibility();
      
      button.replaceWith(button.cloneNode(true));
      button = displayBlock.querySelector('.show-more-btn');
      
      button.onclick = () => {
        expanded = !expanded;
        
        if (!expanded && expandedBlocks.has(filterKey)) {
          collapsedByUser.add(filterKey);
        }
        if (expanded) {
          collapsedByUser.delete(filterKey);
        }
        
        updateItemsVisibility();
      };
    });
  }
  
  function collapseNonExpandedLists() {
    document.querySelectorAll('.facets__display').forEach(displayBlock => {
      const button = displayBlock.querySelector('.show-more-btn');
      const list = displayBlock.querySelector('.js-facet-list--horizontal');
      
      if (!button || !list || displayBlock.classList.contains('facets-expanded')) {
        return;
      }
      
      const items = [...list.children];
      
      items.forEach((item, index) => {
        if (index >= maxVisible) {
          item.style.display = 'none';
        }
      });
      
      button.textContent = textMore;
    });
  }
  
  setupShowMore();
  
  const observer = new MutationObserver((mutations) => {
    let shouldUpdate = false;
    mutations.forEach(mutation => {
      if (mutation.type === 'childList') {
        const addedNodes = Array.from(mutation.addedNodes);
        const removedNodes = Array.from(mutation.removedNodes);
        
        if (addedNodes.some(node => node.nodeType === 1 && (node.classList?.contains('facets__item') || node.querySelector?.('.facets__item'))) ||
            removedNodes.some(node => node.nodeType === 1 && (node.classList?.contains('facets__item') || node.querySelector?.('.facets__item')))) {
          shouldUpdate = true;
        }
      }
    });
    
    if (shouldUpdate) {
      setTimeout(() => {
        setupShowMore();
        setTimeout(collapseNonExpandedLists, 50);
      }, 100);
    }
  });
  
  observer.observe(document.querySelector('.facets-container') || document.body, {
    childList: true,
    subtree: true
  });
  
  document.body.addEventListener('click', (e) => {
    const clickedFilter = e.target.closest('.facets__item');
    const clickedReset = e.target.closest('.js-facet-remove');
    
    if (clickedFilter || clickedReset) {
      const currentExpandedStates = new Map();
      const currentCollapsedStates = new Map();
      
      document.querySelectorAll('.facets__display').forEach((displayBlock) => {
        const details = displayBlock.closest('details');
        const filterLabel = details ? details.querySelector('.facets__summary-text')?.textContent?.trim() : '';
        const filterKey = filterLabel || displayBlock.dataset.index;
        
        const isExpanded = displayBlock.classList.contains('facets-expanded');
        const wasCollapsedByUser = collapsedByUser.has(filterKey);
        
        currentExpandedStates.set(filterKey, isExpanded);
        currentCollapsedStates.set(filterKey, wasCollapsedByUser);
      });
      
      setTimeout(() => {
        expandedBlocks.clear();
        collapsedByUser.clear();
        
        currentExpandedStates.forEach((wasExpanded, filterKey) => {
          if (wasExpanded) {
            expandedBlocks.add(filterKey);
          }
        });
        
        currentCollapsedStates.forEach((wasCollapsed, filterKey) => {
          if (wasCollapsed) {
            collapsedByUser.add(filterKey);
          }
        });
        
        setupShowMore();
      }, 1000);
    }
  });
});
// // desktop filter (end)

// // mobile filter (start)
document.addEventListener('DOMContentLoaded', () => {
  const maxVisible = 8;
  const expandedBlocks = new Set();
  const collapsedByUser = new Set(); 
  
  function setupShowMore() {
    document.querySelectorAll('.js-facet-list--vertical').forEach((list, index) => {
      const displayBlock = list.closest('.facets__display');
      if (!displayBlock) return;
      
      const details = displayBlock.closest('details');
      const filterLabel = details ? details.querySelector('.facets__summary-text')?.textContent?.trim() : '';
      const filterKey = filterLabel || displayBlock.dataset.index || index;
      
      const items = Array.from(list.querySelectorAll('li'));
      
      if (items.length <= maxVisible) {
        const button = displayBlock.querySelector('.show-more-btn');
        if (button) {
          button.style.display = 'none';
        }
        return;
      }
      
      const wasExpanded = expandedBlocks.has(filterKey) && !collapsedByUser.has(filterKey);
      
      const currentlyExpanded = displayBlock.classList.contains('facets-expanded');
      const shouldBeExpanded = wasExpanded || currentlyExpanded;
      
      const button = displayBlock.querySelector('.show-more-btn');
      if (!button) return;
      
      button.style.display = 'block';
      let expanded = shouldBeExpanded;
      
      const updateItemsVisibility = () => {
        items.forEach((item, index) => {
          if (index >= maxVisible) {
            if (expanded) {
              item.classList.remove('hidden-li', 'fade-out');
              item.classList.add('fade-in');
            } else {
              item.classList.remove('fade-in', 'fade-out');
              item.classList.add('hidden-li');
            }
          } else {
            item.classList.remove('hidden-li', 'fade-in', 'fade-out');
          }
        });
        
        button.textContent = expanded ? 'Show less' : 'Show more';
        
        if (expanded) {
          displayBlock.classList.add('facets-expanded');
          expandedBlocks.add(filterKey);
          collapsedByUser.delete(filterKey);
        } else {
          displayBlock.classList.remove('facets-expanded');
          if (shouldBeExpanded && !wasExpanded) {
            expandedBlocks.add(filterKey);
          } else if (!shouldBeExpanded) {
            expandedBlocks.delete(filterKey);
          }
        }
      };
      
      updateItemsVisibility();
      
      const newButton = button.cloneNode(true);
      button.parentNode.replaceChild(newButton, button);
      
      newButton.addEventListener('click', () => {
        expanded = !expanded;
        
        if (!expanded && expandedBlocks.has(filterKey)) {
          collapsedByUser.add(filterKey);
        }
        if (expanded) {
          collapsedByUser.delete(filterKey);
        }
        
        newButton.textContent = expanded ? 'Show less' : 'Show more';

        items.forEach((item, i) => {
          if (i >= maxVisible) {
            if (expanded) {
              item.classList.remove('hidden-li');
              item.classList.add('fade-in');
            } else {
              item.classList.add('fade-out');
              setTimeout(() => {
                item.classList.remove('fade-in', 'fade-out');
                item.classList.add('hidden-li');
              }, 300);
            }
          }
        });
        
        setTimeout(() => {
          if (expanded) {
            displayBlock.classList.add('facets-expanded');
            expandedBlocks.add(filterKey);
            collapsedByUser.delete(filterKey);
          } else {
            displayBlock.classList.remove('facets-expanded');
            expandedBlocks.delete(filterKey);
          }
        }, 100);
      });
    });
  }
  
  function collapseNonExpandedLists() {
    document.querySelectorAll('.facets__display').forEach(displayBlock => {
      const button = displayBlock.querySelector('.show-more-btn');
      const list = displayBlock.querySelector('.js-facet-list--vertical');
      
      if (!button || !list || displayBlock.classList.contains('facets-expanded')) {
        return;
      }
      
      const items = Array.from(list.querySelectorAll('li'));
      
      items.forEach((item, index) => {
        if (index >= maxVisible) {
          item.classList.remove('fade-in', 'fade-out');
          item.classList.add('hidden-li');
        }
      });
      
      button.textContent = 'Show more';
    });
  }
  
  setupShowMore();
  
  const observer = new MutationObserver((mutations) => {
    let shouldUpdate = false;
    mutations.forEach(mutation => {
      if (mutation.type === 'childList') {
        const addedNodes = Array.from(mutation.addedNodes);
        const removedNodes = Array.from(mutation.removedNodes);
        
        if (addedNodes.some(node => node.nodeType === 1 && (node.classList?.contains('facets__item') || node.querySelector?.('.facets__item'))) ||
            removedNodes.some(node => node.nodeType === 1 && (node.classList?.contains('facets__item') || node.querySelector?.('.facets__item')))) {
          shouldUpdate = true;
        }
      }
    });
    
    if (shouldUpdate) {
      setTimeout(() => {
        setupShowMore();
        setTimeout(collapseNonExpandedLists, 50);
      }, 100);
    }
  });
  
  observer.observe(document.querySelector('.facets-container') || document.body, {
    childList: true,
    subtree: true
  });
  
  document.body.addEventListener('click', (e) => {
    const clickedFilter = e.target.closest('.facets__item');
    const clickedReset = e.target.closest('.js-facet-remove');
    
    if (clickedFilter || clickedReset) {
      const clickedFilterBlock = clickedFilter ? 
        clickedFilter.closest('.facets__display') : 
        (clickedReset ? clickedReset.closest('.facets__display') : null);
      
      const currentExpandedStates = new Map();
      const currentCollapsedStates = new Map();
      
      document.querySelectorAll('.facets__display').forEach((displayBlock) => {
        const details = displayBlock.closest('details');
        const filterLabel = details ? details.querySelector('.facets__summary-text')?.textContent?.trim() : '';
        const filterKey = filterLabel || displayBlock.dataset.index;
        
        const isExpanded = displayBlock.classList.contains('facets-expanded');
        const wasCollapsedByUser = collapsedByUser.has(filterKey);
        
        currentExpandedStates.set(filterKey, isExpanded);
        currentCollapsedStates.set(filterKey, wasCollapsedByUser);
        
        if (displayBlock !== clickedFilterBlock && isExpanded) {
          expandedBlocks.add(filterKey);
          collapsedByUser.delete(filterKey);
        }
      });
      
      setTimeout(() => {
        currentExpandedStates.forEach((wasExpanded, filterKey) => {
          if (wasExpanded) {
            expandedBlocks.add(filterKey);
          }
        });
        
        currentCollapsedStates.forEach((wasCollapsed, filterKey) => {
          if (wasCollapsed) {
            collapsedByUser.add(filterKey);
          }
        });
        
        setupShowMore();
      }, 1000);
    }
  });
});
// mobile filter (end)


// filter block (start)
document.addEventListener('DOMContentLoaded', () => {
  const filterHeading = document.querySelector('.collection-heading');

  if (filterHeading) {
    const containerParent = filterHeading.parentElement;
    
    if (containerParent) {
      containerParent.classList.add('filter-wrapper')      
    }
  }
});


// // filter block (end)